import request from "@/utils/request";

/**
 *我的简历列表
 * @returns {AxiosPromise}
 */
export function getMyCvList() {
  return request({
    url: '/job/cv/getMyCvList',
    method: 'get'
  })
}
/**
 *我的简历详情
 * @returns {AxiosPromise}
 */
export function getMyCvView(id) {
  return request({
    url: '/job/cv/getCvView',
    method: 'get',
    params: {id: id}
  })
}
/**
 *删除简历
 * @param data
 * @returns {AxiosPromise}
 */
export function delMyCv(basicId) {
  return request({
    url: '/job/cv/delMyCv',
    method: 'get',
    params: {basicId: basicId}
  })
}
/**
 *保存基本信息
 * @param data
 * @returns {AxiosPromise}
 */
export function saveBaseInfo(data) {
  return request({
    url: '/job/cv/saveBaseInfo',
    method: 'post',
    data
  })
}

/**
 *刷新简历
 * @param data
 * @returns {AxiosPromise}
 */
export function refreshMyCv(basicId) {
  return request({
    url: '/job/cv/refreshMyCv',
    method: 'get',
    params: {basicId: basicId}
  })
}

/**
 *保存求职意向
 * @param data
 * @returns {AxiosPromise}
 */
export function saveWorkRequired(data) {
  return request({
    url: '/job/cv/saveWorkRequired',
    method: 'post',
    data
  })
}

/**
 *保存工作经验
 * @param data
 * @returns {AxiosPromise}
 */
export function saveWorkExperience(data) {
  return request({
    url: '/job/cv/saveWorkExperience',
    method: 'post',
    data
  })
}

/**
 *获取工作经验
 * @param data
 * @returns {AxiosPromise}
 */
export function getWorkExperience(id) {
  return request({
    url: '/job/cv/getWorkExperience',
    method: 'get',
    params: {id: id}
  })
}

/**
 *删除工作经验
 * @param data
 * @returns {AxiosPromise}
 */
export function delWorkExperience(id) {
  return request({
    url: '/job/cv/delWorkExperience',
    method: 'get',
    params: {id: id}
  })
}

/**
 *保存教育经历
 * @param data
 * @returns {AxiosPromise}
 */
export function saveEduExperience(data) {
  return request({
    url: '/job/cv/saveEduExperience',
    method: 'post',
    data
  })
}

/**
 *获取教育经历详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getEduExpirence(id) {
  return request({
    url: '/job/cv/getEduExpirence',
    method: 'get',
    params: {id: id}
  })
}

/**
 *删除教育经历详情
 * @param data
 * @returns {AxiosPromise}
 */
export function delEduExpirence(id) {
  return request({
    url: '/job/cv/delEduExpirence',
    method: 'get',
    params: {id: id}
  })
}

/**
 *保存培训经历
 * @param data
 * @returns {AxiosPromise}
 */
export function saveTrainExperience(data) {
  return request({
    url: '/job/cv/saveTrainExperience',
    method: 'post',
    data
  })
}

/**
 *获取培训经历详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getTrainExperience(id) {
  return request({
    url: '/job/cv/getTrainExperience',
    method: 'get',
    params: {id: id}
  })
}

/**
 *删除培训经历详情
 * @param data
 * @returns {AxiosPromise}
 */
export function delTrainExperience(id) {
  return request({
    url: '/job/cv/delTrainExperience',
    method: 'get',
    params: {id: id}
  })
}

/**
 *保存语言能力
 * @param data
 * @returns {AxiosPromise}
 */
export function saveLanguageAbility(data) {
  return request({
    url: '/job/cv/saveLanguageAbility',
    method: 'post',
    data
  })
}

/**
 *获取语言能力详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getLanguageAbility(id) {
  return request({
    url: '/job/cv/getLanguageAbility',
    method: 'get',
    params: {id: id}
  })
}

/**
 *删除语言能力详情
 * @param data
 * @returns {AxiosPromise}
 */
export function delLanguageAbility(id) {
  return request({
    url: '/job/cv/delLanguageAbility',
    method: 'get',
    params: {id: id}
  })
}

/**
 *保存其他技能
 * @param data
 * @returns {AxiosPromise}
 */
export function saveExtSkill(data) {
  return request({
    url: '/job/cv/saveExtSkill',
    method: 'post',
    data
  })
}

/**
 *获取其他技能详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getExtSkill(id) {
  return request({
    url: '/job/cv/getExtSkill',
    method: 'get',
    params: {id: id}
  })
}

/**
 *删除其他技能详情
 * @param data
 * @returns {AxiosPromise}
 */
export function delExtSkill(id) {
  return request({
    url: '/job/cv/delExtSkill',
    method: 'get',
    params: {id: id}
  })
}

/**
 *获取CV的枚举值
 * @returns {AxiosPromise}
 */
export function getCvEnum() {
  return request({
    url: '/job/cv/getCvEnum',
    method: 'get'
  })
}

/**
 *获取CV信息
 * @returns {AxiosPromise}
 */
export function getCvInfo(data) {
  return request({
    url: '/job/cv/getCvList',
    method: 'post',
    data
  })
}

/**
 *收藏
 * @param data
 * @returns {AxiosPromise}
 */
export function saveCollection(data) {
  return request({
    url: '/job/cv/saveCollection',
    method: 'post',
    data
  })
}
/**
 *取消收藏
 * @param data
 * @returns {AxiosPromise}
 */
export function delCollection(basicId) {
  return request({
    url: '/job/cv/delCollection',
    method: 'get',
    params: {basicId: basicId}
  })
}

/**
 *更改收藏类型
 * @param data
 * @returns {AxiosPromise}
 */
export function updateCollectionType(data) {
  return request({
    url: '/job/cv/updateCollectionType',
    method: 'post',
    data
  })
}



/**
 *获取收藏简历
 * @param data
 * @returns {AxiosPromise}
 */
export function getCollection(data) {
  return request({
    url: '/job/cv/getCollectionList',
    method: 'post',
    data
  })
}

/**
 * 获取收藏简历总数
 * @returns {AxiosPromise}
 */
export function  getCollectionCount() {
  return request({
    url: '/job/cv/getCollectionCount',
    method: 'get'
  })
}

/**
 *获取行业列表
 * @returns {AxiosPromise}
 */
export function getIndustryList() {
  return request({
    url: '/job/cv/getIndustryList',
    method: 'get'
  })
}
/**
 *获取岗位和职务
 * @returns {AxiosPromise}
 */
export function getJobList() {
  return request({
    url: '/job/cv/getJobList',
    method: 'get'
  })
}

/**
 *获取简历详情
 * @param id
 * @returns {AxiosPromise}
 */
export function getCvDetail(id) {
  return request({
    url: '/job/cv/getMyCvView',
    method: 'get',
    params: {id: id}
  })
}

/**
 *获取企业列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getEnterpriseList(data) {
  return request({
    url: '/user/enterprise/getEnterpriseAll',
    method: 'post',
    data
  })
}

/**
 *保存关联关系
 * @param data
 * @returns {AxiosPromise}
 */
export function saveEnterpriseAndCvLink(data) {
  return request({
    url: '/job/cv/saveEnterpriseAndCvLink',
    method: 'post',
    data
  })
}
/**
 *获取屏蔽企业
 * @param data
 * @returns {AxiosPromise}
 */
export function getBlockEnterpriseList(data) {
  return request({
    url: '/user/enterprise/getBlockEnterpriseList',
    method: 'post',
    data
  })
}
/**
 *获取简历活跃情况
 * @param data
 * @returns {AxiosPromise}
 */
export function getCvActive(basicId) {
  return request({
    url: '/job/cv/getCvActive',
    method: 'get',
    params: {basicId: basicId}
  })
}

export function downloadCv(basicId) {
  return request({
    url: '/job/cv/download',
    method: 'get',
    params: {basicId: basicId}
  })
}

export function operationStatistics() {
  return request({
    url: '/job/cv/operation/statistics',
    method: 'get'
  })
}

export function getMyCvViewEnt(id) {
  return request({
    url: '/job/cv/getCvView',
    method: 'get',
    params: {id: id,apply:1}
  })
}

/**
 *获取收藏简历
 * @param data
 * @returns {AxiosPromise}
 */
export function getDownload(data) {
  return request({
    url: '/job/cv/getCvDownloadList',
    method: 'post',
    data
  })
}

export function delDownloadRecord(basicId) {
  return request({
    url: '/job/cv/delDownloadRecord',
    method: 'get',
    params: {cvBaseId: basicId}
  })
}

export function seachCvList(data) {
  return request({
    url: '/job/cv/seachCvList',
    method: 'post',
    data,
    headers: {
      "hideLoading": true
    }
  })
}

/**
 *修改隐私信息
 * @param data
 * @returns {AxiosPromise}
 */
export function updatePrivateConfig(data) {
  return request({
    url: '/job/cv/updatePrivateConfig',
    method: 'post',
    data
  })
}



/**
 *获取个人测评
 * @param data
 * @returns {AxiosPromise}
 */
export function getPersonalSubjectList(data) {
  return request({
    url: '/job/dar/getPersonalSubjectList',
    method: 'post',
    data
  })
}

/**
 *列表
 * @returns {AxiosPromise}
 */
 export function getCvDownloadAndView(data) {
  return request({
    url: '/job/cv/getCvDownloadAndView',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/cv.js